import { ITooltipProps, Tooltip } from '@cian/ui-kit';
import * as React from 'react';

export interface ITooltipOptionalProps extends ITooltipProps {
  visible: boolean;
}

export function TooltipOptional(props: ITooltipOptionalProps) {
  return props.visible ? <Tooltip {...props}>{props.children}</Tooltip> : props.children;
}
